import { getWithdrawLoanData } from "@Redux/ApplyLoan/action";
import { getUserDetail } from "@Redux/GeneralDetails/action";
import { getStatus, upiPay } from "@Redux/Payment/Payment";
import "@Styles/mandate.css";
import React, { useEffect, useReducer, useState } from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { withRouter } from "../../../hooks/withRouter";
import UpiIcon from "../../../../src/Images/NewUI/upiicon.png";
import upilable from "../../../../src/Images/NewUI/upilable.jpg";
import upilogos from "../../../../src/Images/NewUI/upilogos.png";
import ToastMsg from "../../../helper/ToastMsg";
import Heading from "../Common/MainHeading";

const ClosureRepay = (props) => {
  const navigate = useNavigate();
  const loanData = JSON.parse(
    new URLSearchParams(window.location.search)?.get("loanDetails")
  );
  const from = new URLSearchParams(window.location.search)?.get("from");
  // console.log(from, "frr");
  const token = props?.user?.User?.token || localStorage.getItem("gpay_token");
  const [amount, setAmount] = useState(null);
  const [dueAmount, setDueAmount] = useState(null);
  const [convenince, setConvenince] = useState(null);
  const [loanDetails, setLoanDetails] = useState(null);
  const [finalAmount, setFinalAmount] = useState(null);
  const [isChecked, setIsChecked] = useState(true);
  const [defaultChecked, setDefaultChecked] = useState(true);
  const [loader, setLoader] = useState(false);
  const [note, setNote] = useState(null);
  // const [note, setNote] = useState(null);
  const [paybleAmount, setPaybleAmount] = useState(0);
  const [upiAddress, setUpiAddress] = useState("");
  const [amountType, setAmountType] = useState("dueAmount");

  // const handleChange = (e) => {
  //   let value = e.target.value;
  //   let name = e.target.name;
  //   if (value === "" || (name === "note" && nameValidation.test(value))) {
  //     setNote(value.slice(0, 50));
  //   }
  // };
  const fnC = async (value) => {
    value < dueAmount ? setAmount(value) : setAmount(dueAmount);
  };

  const handleChangeAmount = async (e) => {
    let value = e.target.value;
    //let value = e.target.value.slice(0, dueAmount.length );
    //console.log(value, "hello there *****");
    await fnC(value);
    //console.log(amount,"state after", value, value < dueAmount? value:dueAmount)
    //console.log( typeof(parseInt(amount)) ,"hello there 22222");
    await taxCalculationEnterAmount(
      loanDetails,
      value < dueAmount ? value : dueAmount
    );
  };
  const redirectToPayment = () => {
 
    let paymentDetails = {
      amount: Math.round(paybleAmount),
      note: note,
      convenince: Math.round(convenince),
      paymentGatewayType: loanDetails?.payment_gateway,
    };
    navigate(
      `/upi-payment?paymentDetails=${JSON.stringify(paymentDetails)}`
    );
  };
  // const redirectToPayment = () => {
  // let paymentDetails = {
  //   amount: paybleAmount,
  //   // note: note,
  //   convenince: convenince.toFixed(2),
  //   paymentGatewayType: loanDetails?.payment_gateway,
  // };

  //   submitPayment()
  //   props.history.push(
  //     `/upi-payment?paymentDetails=${JSON.stringify(paymentDetails)}`
  //   );
  // };

  useEffect(() => {
  

    let data = {};
  
      // console.log("www");
      props
        .getWithdrawLoanData('foreclosure', token)
        .then((res) => {
          if (res.status === 200) {
            const loanData = res.data.data;
            // loanData.payment_gateway = "icici"
            setDueAmount(loanData?.due_amount);
            setLoanDetails(loanData);
            // console.log("loanData", res?.data?.data);
            taxCalculation(loanData);
          }
        })
        .catch((err) => {
          setLoader(false);
          if (err.response?.status === 401) {
            window.location.href = "/";
            localStorage.removeItem("gpay_token");
          }
          let error = err?.response?.data?.error;
          ToastMsg(error, "error");
          // console.log(err);
        });


  }, []);
  console.log(loanDetails, "loanDetails******");
  const handleAmount = (amountType, amount) => {
    setPaybleAmount(0);
    setFinalAmount(0);
    if (amountType === "dueAmount") {
      setAmountType("dueAmount");
      taxCalculation(loanDetails);
      setDueAmount(amount);
      setAmount("");
      setIsChecked(true);
      setDefaultChecked(true);
    }
    if (amountType === "enterAmount") {
      setAmountType("enterAmount");
      setAmount("");
      setIsChecked(false);
      setDefaultChecked(false);
    }
  };

  //Tax and gst calculation
  const taxCalculation = (data) => {
    let taxDetails = data;
    let taxAmount = (taxDetails?.due_amount * taxDetails?.tax) / 100;
    let gstAmount = (taxAmount * 18) / 100;
    let finalAmount = gstAmount + taxAmount + taxDetails?.due_amount;
    setConvenince(gstAmount + taxAmount);
    setFinalAmount(finalAmount);
    setPaybleAmount(taxDetails?.due_amount);
    return finalAmount;
  };
  //Tax and gst calculation
  const taxCalculationEnterAmount = (data, value) => {
    // console.log(value,"value")
    let taxDetails = data;
    // console.log("taxCalculationEnterAmount", taxDetails, value);
    let taxAmount = (value * taxDetails?.tax) / 100;
    let gstAmount = (taxAmount * 18) / 100;
    let finalAmount = gstAmount + taxAmount + Number(value);
    // console.log("sjkjkdfshfsjkhjfks", gstAmount, taxAmount, value, finalAmount);
    setConvenince(gstAmount + taxAmount);
    setFinalAmount(finalAmount);
    setPaybleAmount(value);
    return finalAmount;
  };

  const [btnDisable, setBtnDisable] = useState(true);

  const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)+$/;
  const [state, setState] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      show: false,
      transId: "",
      upiAddress: "",
      trasDetail: "",
      minutes: 0,
      seconds: 0,
      loanData: JSON.parse(
        new URLSearchParams(window.location.search)?.get("paymentDetails")
      ),
    }
  );
  const [timeLeft, setTimeLeft] = useState(0);

  const handleClose = (type) => {
    if (type === "delay") {
      setState({ show: false });
      navigate("/dashboard_s");
    } else {
      setState({ show: false });
    }
  };
  const handleShow = () => {
    setState({ show: true });
  };
  // const btndisablecheck = () =>{
  //   setState({ [e.target.name]: e.target.value });
  //   if(state?.upiAddress.match(regex) && state?.upiAddress.length < 5){
  //     alert("jnasndbfj")
  //     console.log(state?.upiAddress.match(regex),"regix*****");
  //     setBtnDisable(true)
  //   }
  // }
  const handleChange = (e) => {
    setState({ [e.target.name]: e.target.value });
    // console.log(e.target.value, "************", (e.target.value).length);
    if (e.target.value.match(regex) && e.target.value.length > 5) {
      setBtnDisable(false);
    } else if (!e.target.value.match(regex) || e.target.value.length < 5) {
      setBtnDisable(true);
    }
  };


  const submitPayment = () => {
    let token = props?.user?.User?.token || localStorage.getItem("gpay_token");
    let data = {
      amount: paybleAmount,
      note: "Transaction",
      upi_address: state?.upiAddress,
      fee: convenince.toFixed(2),
    };
    console.log(loanDetails?.payment_gateway, "fhjhkjlkjh");
    // let paymentGatewayType = state?.loanData.paymentGatewayType;
    props
      .upiPay(data, token, loanDetails?.payment_gateway)
      .then((res) => {
        // alert("vbnmmajor")
        // console.log(res,"vbnmmajor");
        if (res.status === 200) {
          // console.log("hi i am in 1");
          if (loanDetails?.payment_gateway !== "icici") {
            let transId = res?.data?.data?.transaction_id;
            // console.log("hi i am in 2");
            setState({ transId: transId });
            // console.log("hi i am in 3");
            getPaymentStatus(transId);
            // console.log("hi i am in");
            window.open(res?.data?.data?.url, "_blank");
          } else {
            let transId = res?.data?.trasaction_id;
            setState({ transId: transId });
            getPaymentStatus(transId);
          }
          handleShow();
          setTimeLeft(90);
        }
      })
      .catch((err) => {
        // console.log(err,"hellllo")
        // this.setState({ loader: false });
        if (err.response?.status === 401) {
          window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        if (err.response?.status === 400) {
          let error = err?.response?.data?.error;
          ToastMsg(error, "error");
          // console.log(err);
        }
      });
  };
  const getPaymentStatus = (transId) => {
    let token = props?.user?.User?.token || localStorage.getItem("gpay_token");
    let data = {
      transaction_id: transId,
    };
    props
      .getStatus(data, token)
      .then((res) => {
        if (res.status === 200) {
          // console.log("status", res.data.status === "FAILURE");
          setState({ trasDetail: res.data });
          if (res.data.status === "CREDITED")
            navigate(
              `/upi-payment-success?paymentDetails=${JSON.stringify(res.data)}`
            );
        }
        if (res.data.status === "FAILURE") {
          navigate(
            `/upi-payment-fail?paymentDetails=${JSON.stringify(res.data)}`
          );
        }
        if (res.data.status === "IN PROCESS") {
        }
      })
      .catch((err) => {
        this.setState({ loader: false });
        if (err.response?.status === 401) {
          window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        // console.log(err);
      });
  };

  //  useEffect(() =>{
  //   if (state?.loanData.paymentGatewayType !== "icici"){
  //     submitPayment()
  //   }
  //  }, [])

  useEffect(() => {
    // console.log("timeLeft", timeLeft);
    if (timeLeft === 0) {
      // console.log("TIME LEFT IS 0");
      setTimeLeft(null);
    }
  }, []);

  useEffect(() => {
    if (state?.transId && timeLeft > 0) {
      const interval = setInterval(() => {
        getPaymentStatus(state?.transId);
        // console.log("timeLeft", timeLeft);
        setTimeLeft(Number(timeLeft) - 2);
      }, 2000);
      return () => clearInterval(interval);
    }
  }, [timeLeft]);

  let { show, transId, minutes, seconds } = state;

  // console.log(state?.upiAddress,"gatevytype");
  return (
    <div id="background" className="main_div">
      <div className="container ">
        <div className="shadowline pb-0">
          <Heading headingText={"Payment"} history={props.history} />
        </div>
        <div className="pb-4 ">
          <div className="text-center repay_main ">
            <img
              className="pb-25"
              width={320}
              height={190}
              src={upilable}
              alt="upi_img"
            />
            {/* <span>Paying to Payme India</span> */}
            <span className="Total_amount2 newtotalamount">
              {"₹ " + finalAmount?.toFixed(2)}
            </span>
            <img
              className=""
              width={270}
              height={18}
              src={upilogos}
              alt="upi_img"
            />
            <h6 className="mb-10x">
              You will be charged a convenience fee of ₹{" "}
              {convenince?.toFixed(2)}
            </h6>
          </div>
          {loanDetails?.payment_gateway == "icici" ? (
            <div className="lower_payment_div upi_payment mt-80 ">
              {" "}
              <label className="upiId">Please enter UPI ID:</label>{" "}
              <div className="image-remain upiidinputdesign margin-auto">
                <input
                  type="text"
                  className="upiidinputdesign margin-auto margin-border-padding-zero inputRepayClose border-radius-10"
                  placeholder=" eg. yournumber@paytm"
                  name="upiAddress"
                  value={state?.upiAddress}
                  onChange={handleChange}
                />
                <img
                  style={{ position: "absolute" }}
                  className="upiIconfix repayUpi"
                  width={36}
                  height={36}
                  src={UpiIcon}
                ></img>
              </div>
            </div>
          ) : (
            ""
          )}

          {/* <div className="lower_payment_div">
            <input
              type="text"
              placeholder="Note"
              name="note"
              value={note}
              onChange={handleChange}
            />
          </div> */}
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div className="text-center pt-4 ">
              {loanDetails?.payment_gateway == "icici" ? (
                <>
                  {btnDisable ? (
                    <div
                      onClick={submitPayment}
                      className="PayNowBtn blur ml-0 mr-0 mb-37"
                      // style={{ width: "100%" }}
                      disabled={finalAmount === 0}
                    >
                      Pay now
                    </div>
                  ) : (
                    <div
                      onClick={submitPayment}
                      className="PayNowBtn ml-0 mr-0"
                      // style={{ width: "100%" }}
                      disabled={finalAmount === 0}
                    >
                      Pay now
                    </div>
                  )}
                </>
              ) : (
                <div
                  onClick={submitPayment}
                  className="PayNowBtn ml-0 mr-0"
                  // style={{ width: "100%" }}
                  disabled={finalAmount === 0}
                >
                  Pay Now
                </div>
              )}
            </div>
          </div>
        </div>
        <Modal show={show} onShow={handleShow} centered className="loan_mn">
          {" "}
          <Modal.Body>
            {" "}
            <div className="popup-div" style={{ textAlign: "center" }}>
              {" "}
              {timeLeft === 0 ? (
                <span className="">
                  {" "}
                  It taking too much time to get response, we will notify when
                  payment is update!{" "}
                </span>
              ) : (
                <span className="">
                  {" "}
                  Please accept the request from MMB on your UPI app!{" "}
                </span>
              )}
            </div>{" "}
            <div  class="d-flex justify-content-center ">
              {" "}
              <div class="spinner-border" role="status">
                {" "}
                <span class="visually-hidden">Loading...</span>{" "}
              </div>{" "}
            </div>{" "}
            <div className="text-center pt-4">
              {" "}
              <button
                onClick={
                  timeLeft === 0 ? () => handleClose("delay") : handleClose
                }
                className="btn bg-orange text-white rounded-pill px-5 py-3 mb-3"
                style={{ width: "100%" }}
              >
                {" "}
                Cancel{" "}
              </button>{" "}
            </div>{" "}
          </Modal.Body>{" "}
        </Modal>{" "}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};
export default withRouter(connect(mapStateToProps, {
  getWithdrawLoanData,
  getUserDetail,
  upiPay,
  getStatus,
})(ClosureRepay));